export default "__VITE_ASSET__B0Whd3en__"